module.exports = __webpack_public_path__ + "static/media/certificate2.b0fd04bd.png";